import { getRequest } from "./ApiService";

/**
 * Fetches consolidated financial statements from /api/app/financial-statements/
 *
 * @param {Object} params
 * @param {number} [params.roundNumber] - specific round
 * @param {number} [params.roundLte] - all rounds up to this number
 * @param {number} [params.teamId] - team ID (instructor view)
 * @returns {Promise<{ incomeStatement, balanceSheet, cashflow, projections, financialAnalysis }>}
 */
export function fetchFinancialStatements({ roundNumber, roundLte, teamId } = {}) {
  let url = `${process.env.REACT_APP_API_URL}app/financial-statements/`;
  const params = [];
  if (roundLte != null) {
    params.push(`round_lte=${roundLte}`);
  } else if (roundNumber != null) {
    params.push(`round_number=${roundNumber}`);
  }
  if (teamId != null) {
    params.push(`team_id=${teamId}`);
  }
  if (params.length > 0) {
    url += `?${params.join('&')}`;
  }

  return getRequest(url).then(({ body }) => ({
    incomeStatement: body.income_statement || [],
    balanceSheet: body.balance_sheet || [],
    cashflow: body.cashflow || [],
    projections: body.projections || [],
    financialAnalysis: body.financial_analysis || [],
  }));
}



// WEBPACK FOOTER //
// ./src/api/FinancialStatementsService.js